export const GET_VIDEO_REPORT="GET_VIDEO_REPORT"
export const DELETE_VIDEO_REPORT="DELETE_VIDEO_REPORT"
export const CLEAN_REPORT = "CLEAN_REPORT";
